import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { useEffect, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { Conversation } from '../models/conversation';

const resolver = classValidatorResolver(Conversation);

export const useConversationSettingForm = (conversation?: Conversation) => {
  const [avatarFile, setAvatarFile] = useState<File | null>(null);
  const [isUploadingAvatar, setIsUploadingAvatar] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const formMethods = useForm<Conversation>({
    resolver,
    defaultValues: new Conversation({
      conversationName: conversation?.conversationName || '',
      conversationAvatarRef: conversation?.conversationAvatarRef || ''
    }),
    reValidateMode: 'onChange'
  });

  const { handleSubmit, control, reset } = formMethods;

  // Watch form changes to track unsaved changes
  const [conversationName, conversationAvatarRef = ''] = useWatch({
    control,
    name: ['conversationName', 'conversationAvatarRef']
  });

  useEffect(() => {
    const hasChanges =
      conversationName !== (conversation?.conversationName || '') ||
      conversationAvatarRef !== (conversation?.conversationAvatarRef || '') ||
      avatarFile !== null;
    setHasUnsavedChanges(hasChanges);
  }, [
    conversationName,
    conversationAvatarRef,
    avatarFile,
    conversation?.conversationName,
    conversation?.conversationAvatarRef
  ]);

  useEffect(() => {
    if (conversation) {
      reset({
        conversationName: conversation.conversationName,
        conversationAvatarRef: conversation.conversationAvatarRef
      });
      setAvatarFile(null);
    }
  }, [conversation, reset, setAvatarFile]);

  return {
    // Form
    formMethods,
    handleSubmit,
    control,
    reset,

    // State
    avatarFile,
    setAvatarFile,
    isUploadingAvatar,
    setIsUploadingAvatar,
    hasUnsavedChanges
  };
};
